<template>
  <div class="content-wrapper">
    <div class="content">
      <h1>Bienvenue</h1>
      <p>
        Le canton de Vaud abrite une population plurielle ; une richesse qui
        pose aussi un défi d’interculturalité pour l’Administration cantonale
        vaudoise (ACV) et ses 40 000* collaboratrices et collaborateurs.
      </p>
      <p>
        L’intégration en terre vaudoise est l’affaire de nous toutes et tous.
      </p>
      <p>
        Suivant un chemin en 10 étapes, le Bureau cantonal pour l’intégration
        des étrangers et la prévention du racisme (BCI) vous propose de
        réfléchir à nos pratiques institutionnelles, tout en découvrant des
        pistes et outils.
      </p>
      <h2>Votre anonymat est respecté</h2>
      <p>
        Vos réponses à ce quiz nous seront envoyées de manière anonyme. Aucune
        information permettant de vous identifier ne sera récoltée.
      </p>
      <p>
        <small>*Administration cantonale vaudoise au sens large, Sources : DGRH (juin 2022), CHUV & UNIL (décembre 2021).
</small>
      </p>

      <hi-button-text :to="'/prior/'" name="C’est parti !"></hi-button-text>
    </div>
    <div class="illustration illustration-start">
      <img src="/assets/static/bci-mirrors.svg" />
    </div>
    <router-view />
  </div>
</template>

<script>
import SessionMixin from "./../mixins/SessionCookieMixin";

export default {
  mixins: [SessionMixin],
  data() {
    return {};
  },
  mounted() {
    console.log("BCI started");
    this.createSession()
      .then((msg) => console.log(msg))
      .catch((error) => console.log(error));
  },
};
</script>
